import React, { useState, useEffect } from "react";
import { ReactComponent as SuccessIcon } from "../../../../../../assets/success-eligibility.svg";
import { ReactComponent as FailedIcon } from "../../../../../../assets/failed-eligibility.svg";
import { ReactComponent as HeadSetIcon } from "../../../../../../assets/fi-rr-headset.svg";
import { ReactComponent as DocumentIcon } from "../../../../../../assets/fi-rr-document.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";

const EligibilityResult = ({
  geteligible,
  getCompensationamount,
  getCompensationmessage,
}) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true); // Add a loading state

  // Log changes to geteligible
  useEffect(() => {
    console.log("geteligible updated:", geteligible);
    if (geteligible !== undefined) {
      setIsLoading(false); // Set loading to false once geteligible has a value
    }
  }, [geteligible]);

  if (isLoading) {
    return <div>Loading...</div>; // Show a loading state while waiting for geteligible
  }

  return (
    <div className="stepper-container">
      <h3 className="stepper-header">Eligibility results</h3>
      {geteligible ? (
        <div>
          <SuccessIcon />
          <div style={{ marginTop: "30px" }}>
            <h4 className="result-header-text" style={{ color: "#314064" }}>
              Congratulations!
            </h4>
            <h6 className="result-sub-text">
              Great news! {getCompensationmessage}!
            </h6>
          </div>
        </div>
      ) : (
        <div className="result-wrapper">
          <FailedIcon />
          <div style={{ marginTop: "30px" }}>
            <h4 className="result-header-text" style={{ color: "#D04244" }}>
              We're sorry...
            </h4>
            <h6 className="result-sub-text">
              Unfortunately, based on current regulations, your case does not
              qualify for compensation.
            </h6>
            <div className="support-wrapper">
              <div className="customer-support-wrapper sub-text">
                <span onClick={() => navigate("/contact-us")}>
                  <HeadSetIcon />
                  Contact our support team
                </span>
              </div>
              <div className="customer-support-wrapper sub-text">
                <span onClick={() => navigate("/disclaimer")}>
                  <DocumentIcon />
                  Read more about your rights
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EligibilityResult;
